import type { RolePermissionResponse } from '@/types/apps/role-permission.type';
import type {
    ApiResponse,
    PaginatedResult,
    QueryParams,
} from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import type { Showable } from '@/types/service/showable.interface';

export interface RolePermissionServiceInterface {}

type RolePermissionListResponse = ApiResponse<
    PaginatedResult<RolePermissionResponse>
>;

export class RolePermissionService implements Showable {
    public constructor(private apiClient: BaseApiClientInterface) {}

    protected endpoints = {
        base: () => '/api/admin/get-role-permission',
        detail: (id: string) => `/api/admin/get-role-permission/${id}`,
    };

    public detail(
        id: string,
        params?: QueryParams
    ): Promise<ApiResponse<RolePermissionListResponse>> {
        const url = this.endpoints.detail(id);

        return this.apiClient.fetchApi(url, params);
    }
}
